import { ListItemButton } from '@mui/material';

import clsx from 'clsx';

import { NavText } from './NavText';

import { NavItemType } from '../navigation.types';

export const SingleLevelNavItem = ({
  text,
  isExternal,
  isActive,
  buttonProps,
  path,
  publicPath,
  onClick,
  isNewTheme,
}: NavItemType) => {
  const isSelected = path || publicPath ? isActive : false;

  const externalProps = isExternal
    ? {
        component: 'a',
        href: path,
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : undefined;

  const onClickFn = () => {
    if (buttonProps?.onClick) {
      buttonProps.onClick();
    }
    onClick?.();
  };

  return (
    <ListItemButton
      className={clsx('nav-item', { 'selected-nav': isSelected })}
      selected={isSelected}
      component="span"
      {...buttonProps}
      {...externalProps}
    >
      <span className="nav-item-inner" onClick={onClickFn}>
        <NavText>{text}</NavText>
      </span>
    </ListItemButton>
  );
};
